import { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNotification } from 'hook/useNotification';
import { fErrors } from 'utils/formatError';

const useConf = (configurationRetriever) => {
  const { formatMessage: msg } = useIntl();
  const { addNotification } = useNotification();

  const {
    data: defaultConf,
    isLoading: isConfLoading,
    isFetching: isConfFetching,
    error: confError
  } = configurationRetriever();

  useEffect(() => {
    if (confError) {
      console.error(
        `Error occurred when retrieving default configuration: ${JSON.stringify(confError)}`
      );
      try {
        addNotification({
          type: 'error',
          title: msg({ id: 'notification.error.title' }),
          message: fErrors(msg, confError)
        });
      } catch {
        // Ignore exception
      }
    }
  }, [addNotification, confError, msg]);

  const getValue = useCallback(
    (code, defaultValue = null) => {
      if (!code) {
        return defaultValue;
      }
      const res = getDeepNestedFieldValue(code, defaultConf);
      return res !== null ? res : defaultValue;
    },
    [defaultConf]
  );

  return {
    isLoading: isConfLoading || isConfFetching,
    error: confError,
    getValue
  };

  function getDeepNestedFieldValue(path, obj) {
    if (!obj) {
      return null;
    }

    if (obj[path] !== undefined) {
      return obj[path];
    }

    return path.split('.').reduce((currentValue, key) => {
      if (currentValue === null || currentValue[key] === undefined) {
        return null;
      }
      return currentValue[key];
    }, obj);
  }
};

export default useConf;
